import { NavLink, Outlet } from "react-router-dom";

export default function DashboardLayout() {
  const tabs = [
    {
      name: "Discover",
      path: "discover",
      icon: "/images/discover.png",
      iconActive: "/images/discovers.png",
    },
    {
      name: "For you",
      path: "foryou",
      icon: "/images/foryou-icon.png",
      iconActive: "/images/foryou-icon.png",
    },
    {
      name: "My Events",
      path: "event",
      icon: "/images/event-icon.png",
      iconActive: "/images/event-icon-active.png",
    },
    {
      name: "Sell",
      path: "sell",
      icon: "/images/sell-icon.png",
      iconActive: "/images/sell-icon-active.png",
    },
    {
      name: "My Account",
      path: "settings",
      icon: "/images/settings-icon.png",
      iconActive: "/images/settings-icon-active.png",
    },
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-grow overflow-y-auto">
        <Outlet />
      </div>
      <div className="flex justify-around bg-white border-t py-2 shadow-md">
        {tabs.map((tab) => (
          <NavLink key={tab.name} to={tab.path}>
            {({ isActive }) => (
              <div
                className={`flex flex-col items-center text-[10px] pb-1 ${
                  isActive ? "text-blue-500" : "text-gray-600"
                }`}
              >
                <img
                  src={isActive ? tab.iconActive : tab.icon}
                  alt={tab.name}
                  className="w-7 h-7"
                />
                <span>{tab.name}</span>
              </div>
            )}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
